import React, { useState } from 'react';
import classNames from 'classnames';
import { clipboardUtils, stringUtils } from '@indico-data/utils';
import { Button, Icon, LoadingSpinner, Tooltip } from 'Permafrost/index';
import { StyledCopyableFilename } from './CopyableFilename.styles';
export function CopyableFilename(props) {
    const { className, filename, id, maxNameLength = 50, downloadable, isDownloading, onDownload, } = props;
    const [displayCopySuccess, setDisplayCopySuccess] = useState(false);
    const copyHandler = () => {
        clipboardUtils.copy(filename);
        setDisplayCopySuccess(true);
        setTimeout(() => {
            setDisplayCopySuccess(false);
        }, 2000);
    };
    return (React.createElement(StyledCopyableFilename, { className: className, "data-cy": props['data-cy'] },
        filename.length > maxNameLength ? (React.createElement(React.Fragment, null,
            React.createElement(Tooltip, { questionMark: false, for: "shortened-name" },
                React.createElement("p", null, filename)),
            React.createElement("span", { "data-tip": true, "data-for": "shortened-name", id: id }, stringUtils.maxLengthWithMiddleEllipsis(filename, maxNameLength)))) : (React.createElement("span", { id: id }, filename)),
        React.createElement(Button, { className: "copy-filename", variant: "link-style", onClick: () => copyHandler(), "data-for": "copy-filename", "data-tip": true },
            React.createElement(Icon, { className: classNames({
                    hidden: displayCopySuccess === true,
                }), name: "fa-clipboard", ariaLabel: "copy filename", size: ['16px'] }),
            React.createElement(Icon, { className: classNames('copy-success', {
                    hidden: displayCopySuccess === false,
                }), name: "check", size: ['16px'] })),
        React.createElement(Tooltip, { className: "copy-success__tooltip", questionMark: false, place: 'bottom', for: "copy-filename" }, displayCopySuccess ? 'copied!' : 'copy filename'),
        downloadable && onDownload ? (React.createElement(React.Fragment, null,
            React.createElement(Button, { className: "download-file__button", variant: "link-style", onClick: onDownload, "data-for": "download-filename", "data-tip": true, disabled: isDownloading }, isDownloading ? (React.createElement(LoadingSpinner, { size: '16px' })) : (React.createElement(Icon, { name: "output", ariaLabel: "download file", size: ['16px'] }))),
            React.createElement(Tooltip, { className: "download-success__tooltip", questionMark: false, place: 'bottom', for: "download-filename" }, "download file"))) : null));
}
//# sourceMappingURL=CopyableFilename.js.map